import { render, staticRenderFns } from "./ContactModel.vue?vue&type=template&id=73ec5f10&scoped=true&"
import script from "./ContactModel.vue?vue&type=script&lang=js&"
export * from "./ContactModel.vue?vue&type=script&lang=js&"
import style0 from "./ContactModel.vue?vue&type=style&index=0&id=73ec5f10&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ec5f10",
  null
  
)

export default component.exports